/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendReadinessResponseDto } from '../../models/backend-readiness-response-dto';

export interface ReadyReadyGet$Params {}

export function readyReadyGet(
  http: HttpClient,
  rootUrl: string,
  params?: ReadyReadyGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendReadinessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, readyReadyGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendReadinessResponseDto>;
    }),
  );
}

readyReadyGet.PATH = '/ready';
